import styled from 'styled-components';
import { Typography } from '@elfsight/widget-ui';
import { createReadableClass } from '@elfsight/widget-utils';

interface LabelsItemProps {
  text: string;
}

export const LocationLabelsItem = ({ text }: LabelsItemProps) => {
  return (
    <Label textStyle={{ fontSize: 13, fontWeight: 700, lineHeight: 1.23 }}>
      {text}
    </Label>
  );
};

const Label = styled(Typography).attrs({
  className: createReadableClass({
    component: 'location-labels-item',
    element: 'label'
  })
})``;
